module.exports = __webpack_public_path__ + "img/parceiro2.e4ff3c1b.png";